<template>
  <dara-modal
    ref="modal"
    :title="$t('warning')"
    v-bind="$attrs"
    v-on="$listeners">
    <template #content>
      <div v-if="canDelete()">
        {{ $t('are-you-sure-you-want-to-delete-this-department') }}
      </div>
      <div v-else>
        <dara-p weight="strong" class="pb-2">{{ $t('unable-to-delete-department') }}</dara-p>
        <dara-p v-if="users > 0" size="md">
          {{ users > 1 ? `${$t('there-are')}` : `${$t('there-is')}` }}
          <strong>{{ users > 1 ? `${users} ` + $t('users').toLowerCase() : '1 ' + $t('user').toLowerCase() }}</strong>
          {{ users > 1 ? $t('users-associated-with-this-department') : $t('user-associated-with-this-department') }}
        </dara-p>
        <dara-p v-if="articles > 0" size="md">
          {{ articles > 1 ? `${$t('there-are')}` : `${$t('there-is')}` }}
          <strong>{{ articles > 1 ? `${articles} ` + $t('articles').toLowerCase() : '1 ' + $t('article').toLowerCase() }}</strong>
          {{ articles > 1 ? $t('articles-associated-with-this-department') : $t('article-associated-with-this-department') }}
        </dara-p>
        <dara-p v-if="tracks > 0" size="md">
          {{ tracks > 1 ? `${$t('there-are')}` : `${$t('there-is')}` }}
          <strong>{{ tracks > 1 ? `${tracks} ` + $t('tracks').toLowerCase() : '1 ' + $t('track').toLowerCase() }}</strong>
          {{ tracks > 1 ? $t('tracks-associated-with-this-department') : $t('track-associated-with-this-department') }}
        </dara-p>
        <dara-p v-if="questions > 0" size="md">
          {{ questions > 1 ? `${$t('there-are')}` : `${$t('there-is')}` }}
          <strong>{{ questions > 1 ? `${questions} ` + $t('questions').toLowerCase() : '1 ' + $t('question').toLowerCase() }}</strong>
          {{ questions > 1 ? $t('questions-associated-with-this-department') : $t('question-associated-with-this-department') }}
        </dara-p>
        <dara-p v-if="error" size="sm" color="danger">
          * {{ error }}
        </dara-p>
      </div>
    </template>
    <template #footer>
      <dara-button
        :disabled="!canDelete()"
        class="btn btn-danger"
        size="sm"
        @click="confirm()">
        {{ $t('delete') }}
      </dara-button>
    </template>
  </dara-modal>
</template>

<script>
import { getArticlesQuantityByDepartment } from '@/modules/article/article.service';
import { getDepartmentUsers } from '@/modules/user/user.service';
import { getDepartmentQuestions } from '@/modules/question/question.service';
import { getDepartmentTracks } from '@/modules/track/track.service';
import { translate } from '@/services/translate.service';

export default {
  name: 'DaraModalConfirm',
  props: {
    department: {
      type: Object,
      required: true,
    },
    closeAfterConfirm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      users: 0,
      articles: 0,
      tracks: 0,
      questions: 0,
      error: null,
    };
  },
  mounted() {
    this.getDepartmentUsers();
    this.getDepartmentArticles();
    this.getDepartmentQuestions();
    this.getDepartmentTracks();
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      if (this.closeAfterConfirm) {
        this.$refs.modal.close();
      }
    },
    canDelete() {
      if (this.users > 0 || this.articles > 0 || this.tracks > 0 || this.questions > 0 || this.error) {
        return false;
      }
      return true;
    },
    getDepartmentUsers() {
      getDepartmentUsers(this.department.id)
        .then(({ data }) => {
          this.users = data.length;
        })
        .catch(() => {
          this.error = translate('error-verifying-users-associated-with-department');
        });
    },
    getDepartmentArticles() {
      getArticlesQuantityByDepartment(this.department.id)
        .then(({ data }) => {
          this.articles = data;
        })
        .catch(() => {
          this.error = translate('error-verifying-articles-associated-with-department');
        });
    },
    getDepartmentQuestions() {
      getDepartmentQuestions(this.department.id)
        .then(({ data }) => {
          this.questions = data.length;
        })
        .catch(() => {
          this.error = translate('error-verifying-questions-associated-with-department');
        });
    },
    getDepartmentTracks() {
      getDepartmentTracks(this.department.id)
        .then(({ data }) => {
          this.tracks = data.length;
        })
        .catch(() => {
          this.error = translate('error-verifying-tracks-associated-with-department');
        });
    },
  },
};
</script>
